import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import Legend from '../Custom/Legend';
import CustomTooltip from '../layout/Tooltip';
import ClientList from '../Custom/ClientModal';
import Clock from '../Custom/Clock';
import { generateURL } from '../../utils/helper';
import { session } from '../../Service/APIService';

class AssetHeader extends Component {
  constructor(props) {
    super(props);
    this.popref = React.createRef();
    this.state = {
      isPopupOpen: false,
      Name: '',
      email: '',
      isHandbugerOpen: false,
      clientModal: false,
      role: '',
      img: '',
      msg: '',
      Title: '',
    };
    this.handleAvatarClick = this.handleAvatarClick.bind(this);
    this.onSignOutClick = this.onSignOutClick.bind(this);
    this.onHandburgerClick = this.onHandburgerClick.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.switchAccount = this.switchAccount.bind(this);
  }

  componentDidMount() {
    this.setData();
  }

  async setData() {
    const userObj = session.user();

    const fullName = `${userObj?.fName} ${userObj?.lName}`;
    this.setState({
      Name: fullName,
      email: userObj?.email,
      role: userObj?.roleId,
      img: userObj?.profilePicturePath,
      msg: userObj?.msg,
      Title: userObj?.showTitle,
    });
  }
  onSignOutClick = () => {
    const userObj = session.user();
    const GENERIC_URL = generateURL();
    const URL = `${GENERIC_URL}/member/Logout/${userObj.memberId}`;

    session.clear();

    fetch(URL).then((response) => {
      console.log(response.json());
    });

    // this.props.history.push("/")
    window.location.href = '/';
  };

  switchAccount() {
    this.setState((prevState) => ({ clientModal: !prevState.clientModal }));
  }

  onLegendClick(index) {
    document
      .getElementById(this.props.legendObj[index].id)
      .classList.toggle('_custom_menu_list_active');
    this.props.onLegendClick();
  }

  handleAvatarClick() {
    if (!this.state.isPopupOpen) {
      // attach/remove event handler
      document.addEventListener('click', this.handleOutsideClick, false);
    } else {
      document.removeEventListener('click', this.handleOutsideClick, false);
    }

    this.setState((prevState) => ({ isPopupOpen: !prevState.isPopupOpen }));
  }

  onHandburgerClick() {
    this.setState((prevState) => ({
      isHandbugerOpen: !prevState.isHandbugerOpen,
      isPopupOpen: false,
    }));
  }

  handleOutsideClick(e) {
    // ignore clicks on the component itself
    if (this.node.contains(e.target)) {
      return;
    }

    this.handleAvatarClick();
  }

  renderHeaderIcons() {
    const { iconsObj, onIconActionClick } = this.props;
    return iconsObj.map((x, index) => (
      <li key={`li-${index}`}>
        <a>
          <CustomTooltip id={index} tooltip={x.tooltip} placement={'bottom'}>
            <button
              type="button"
              id={x.id}
              className="btn btn-box-tool"
              onClick={() => onIconActionClick(index)}
              data-original-title="Mark as read"
            >
              <i className={x.iconClass}></i>
            </button>
          </CustomTooltip>
        </a>
      </li>
    ));
  }

  render() {
    const { BrandText, isExport, islegendObj, legendObj } = this.props;
    const { isHandbugerOpen } = this.state;
    let clientLogo = '';
    const defaultConfig = session.config();
    if (defaultConfig) {
      clientLogo = defaultConfig.faviIcon;
    }
    return (
      <div>
        <nav className="navbar navbar-default navbar-fixed-top">
          <div className="container-fluid">
            <div className="navbar-header">
              <button
                type="button"
                className="navbar-toggle"
                onClick={this.onHandburgerClick}
                data-toggle="collapse"
              >
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
              </button>
              <div className="navbar-brand">
                <h3>
                  &nbsp; {BrandText}{' '}
                  <small>
                    <Clock></Clock>
                  </small>
                </h3>
              </div>
            </div>

            <div
              className={
                isHandbugerOpen
                  ? 'collapse show navbar-collapse'
                  : 'collapse navbar-collapse'
              }
              id="bs-example-navbar-collapse-1"
            >
              <div
                className="headerName"
                style={{
                  position: 'absolute',
                  width: '98%',
                  textAlign: 'center',
                  bottom: '2px',
                }}
              >
                <h3>{this.state.Title}</h3>
              </div>
              <ul
                className="nav navbar-nav navbar-right"
                id="headerBar"
                style={{ display: 'flex', alignItems: 'center' }}
              >
                {islegendObj ? (
                  legendObj.map((legend, index) => (
                    <li key={legend.id}>
                      <a>
                        <Legend
                          Text={legend.Text}
                          id={legend.id}
                          color={legend.color}
                          iconClass={legend.iconClass}
                          onLegendClick={this.onLegendClick.bind(this, index)}
                        />
                      </a>
                    </li>
                  ))
                ) : (
                  <li>{this.props.children}</li>
                )}
                {this.renderHeaderIcons()}
                {isExport && (
                  <li>
                    <a>
                      <div className="box-tools">
                        <div className="drpdwn" style={{ float: 'right' }}>
                          <button type="button" className="btn btn-box-tool">
                            <i className={'fa fa fa-download fa_custom'}></i>
                          </button>
                          <div className="drpdwn-content">
                            {this.props.exportObj.map((x) =>
                              x.disable ? (
                                <li key={x.id} className={'disabled'}>
                                  <a key={x.id}>{x.title}</a>
                                </li>
                              ) : (
                                <li
                                  key={x.id}
                                  onClick={() =>
                                    this.props.onExportClick(x.key)
                                  }
                                >
                                  {<a key={x.id}>{x.title}</a>}
                                </li>
                              )
                            )}
                          </div>
                        </div>
                      </div>
                    </a>
                  </li>
                )}
                {this.state.role === 1 && (
                  <li>
                    <a
                      style={{ cursor: 'pointer!important' }}
                      onClick={this.switchAccount}
                    >
                      <CustomTooltip
                        id={'switch'}
                        tooltip={'Switch Client'}
                        placement={'bottom'}
                      >
                        <i
                          className="fa fa-random fa_custom"
                          style={{ marginTop: '4px' }}
                        ></i>
                      </CustomTooltip>
                    </a>
                  </li>
                )}
                <li
                  ref={(node) => {
                    this.node = node;
                  }}
                  className={
                    this.state.isPopupOpen
                      ? 'dropdown user user-menu open'
                      : 'dropdown user user-menu'
                  }
                  onClick={this.handleAvatarClick}
                >
                  <a
                    className="dropdown-toggle"
                    data-toggle="dropdown"
                    aria-expanded="true"
                  >
                    <img
                      src={this.state.img || '/Images/avatar.jpg'}
                      className="user-image img-circle"
                      alt=""
                      width="20"
                      height="20"
                    />
                  </a>
                  <ul className="dropdown-menu">
                    <li className="user-header">
                      <img
                        src={this.state.img || '/Images/avatar.jpg'}
                        className="img-circle"
                        alt=""
                      />
                      <p>{this.state.Name}</p>
                      <span style={{ color: 'rgba(255, 255, 255, 0.8)' }}>
                        {this.state.msg}
                      </span>
                      <p>
                        <small>{this.state.email}</small>
                      </p>
                    </li>
                  </ul>
                </li>
                <li>
                  <a>
                    <img
                      src={clientLogo}
                      className="user-image img-circle"
                      alt=""
                      width="20"
                      height="20"
                    />
                  </a>
                </li>
                <li>
                  <a
                    style={{ cursor: 'pointer!important' }}
                    onClick={this.onSignOutClick}
                  >
                    <CustomTooltip
                      id={'logout'}
                      tooltip={'Log Out'}
                      placement={'bottom'}
                    >
                      <i
                        className="fa fa-sign-out fa_custom"
                        style={{ fontSize: '20px' }}
                      ></i>
                    </CustomTooltip>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
        {this.state.clientModal && (
          <ClientList switchAccount={this.switchAccount.bind(this)} />
        )}
      </div>
    );
  }
}
AssetHeader.propTypes = {
  exportObj: PropTypes.arrayOf(Object),
};

AssetHeader.defaultProps = {
  exportObj: [],
  legendObj: [],
  iconsObj: [],
  isExport: false,
  islegendObj: false,
};

export default withRouter(AssetHeader);
